import { render, staticRenderFns } from "./FBreadcrumb.vue?vue&type=template&id=1603231f&"
import script from "./FBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./FBreadcrumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/souzaramon/repos/personal/fluid/pwa-fluid/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib'
installComponents(component, {VBreadcrumbs})
